export const SITE_URL = "https://www.ridethewave.co";
export const DEFAULT_OG_IMAGE =
  "https://zqmgjchhimqsiuzjwngc.supabase.co/storage/v1/object/public/site-images/og-default.jpg";

export const LOGO_URL =
  "https://zqmgjchhimqsiuzjwngc.supabase.co/storage/v1/object/public/site-images/logo.webp";

export const CONTACT = {
  phone: "(407)-279-0072",
  phoneHref: "tel:+14072790072",
  email: "bookings@ridethewave.co",
  emailHref: "mailto:bookings@ridethewave.co",
};

export const SOCIAL = {
  instagram: "https://www.instagram.com/rtwphotography_/",
  facebook: "https://www.facebook.com/RTWPhotographyLLC/",
  youtube: "https://www.youtube.com/channel/UCnNf_Z97RONaZ2H4nwHuiRw/featured",
  linkedin: "https://www.linkedin.com/company/rtw-photography/about/",
};